<template>
  <div class="user-profile-account-form">
    <section class="mb-5">
      <UserProfileAccount />
    </section>
  </div>
</template>

<script>
  import UserProfileAccount from '@/components/user/profile/account/UserProfileAccount'

  export default {
    components: {
      UserProfileAccount,
    },
  }
</script>

<style scoped lang="scss">
  .user-profile-account-form {
    position: relative;
  }

  .header-text {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    align-items: center;

    &__titles {
      padding-right: 15px;
    }

    &__options {
      flex-shrink: 0;
    }

    h2 {
      font-family: 'Poppins';
      font-size: 18px;
      font-weight: 600;
    }

    h3 {
      font-size: 16px;
    }
  }
</style>